import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { InputAutocompleteComponent } from '../../components/input-autocomplete/input-autocomplete.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import RestService from '../../services/core-rest.service';
import Config from '../../utils/config.service';
import CategoryService from '../../services/category.service';
import Session from '../../utils/session.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';

@Component({
	standalone: true,
	selector: 'modal-service-provider-search',
	templateUrl: './modal-service-provider-search.component.html',
	imports: [ CommonModule, MatSelectModule, TranslatePipe, LoaderOverlayComponent, InputAutocompleteComponent, FormsModule ]
})
export class ModalServiceProviderSearchComponent implements OnInit {
	private restService: RestService = inject(RestService);
	private config: Config = inject(Config);
	private categoryService: CategoryService = inject(CategoryService);
	private session: Session = inject(Session);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private dialogRef = inject(MatDialogRef<ModalServiceProviderSearchComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.vm.formData = {};
		this.initialize();
		
		this.vm.close = this.close;
		this.vm.submit = this.submit;
		this.vm.items = [];
	}
	
	initialize() {
		this.vm.searchLanguages = this.config.getServiceLanguages();
		
		this.vm.handleServiceProviderSearch = this.handleServiceProviderSearch;
		this.vm.handleSelect = this.handleSelect;
		this.vm.removeItem = this.removeItem;
		this.vm.isValidPictureUrl = this.isValidPictureUrl;
		this.vm.getLanguagesText = this.getLanguagesText;
		this.vm.getTagsText = this.getTagsText;
		
		this.vm.isMentalHealthServiceProvider = this.session.getSession().user
			&& this.session.getSession().user.service
			&& this.session.getSession().user.service.mentalHealthServiceProvider;
		this.vm.sessionUserLanguage = this.session.getSession().user && this.session.getSession().user.deviceLanguage;
		
		this.vm.processing = false;
		
		this.restService.getServiceProviderTags({ language: this.vm.sessionUserLanguage })
			.then((tags) => {
				this.vm.searchTags = tags;
			})
			.catch((err) => {
				console.error(err);
			});
		
		this.categoryService.getAll().then((categories) => {
			this.vm.healthFields = categories;
			this.vm.initialized = true;
		});
	}
	
	submit() {
		if (this.vm.processing || !this.vm.initialized) return;
		if (!this.vm.items || this.vm.items.length == 0) {
			this.dialogRef.close(this.vm.chat);
			return;
		}
		this.vm.processing = true;
		
		this.submitServiceProviderToChat().then(
			(res) => {
				this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Chat.NEW_MESSAGE,
					res.flat(), this.vm.chat.id);
				this.dialogRef.close(this.vm.chat);
			},
			(err) => {
				this.vm.processing = false;
			}
		);
	}
	
	isValidPictureUrl(pictureUrl) {
		return pictureUrl && pictureUrl.startsWith('http');
	}
	
	submitServiceProviderToChat() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		
		this.restService.saveServiceProviderShare({ userId: this.vm.chat.privateChatFriend.id }, this.vm.items)
			.then((chatPosts) => {
				deferred.resolve(chatPosts);
			})
			.catch((err) => {
				console.error(err);
				deferred.reject(err);
			});
		
		return deferred.promise;
	}
	
	removeItem(idx) {
		this.vm.items.splice(idx, 1);
	}
	
	handleSelect = (selection: any): void => {
		this.vm.items.push(selection.selectedItem);
	}
	
	getLanguagesText() {
		if (!this.vm.selectedLangs || !this.vm.selectedLangs.length) {
			return this.angularFilterHelperService.translate('Services.Filter.Languages');
		}
		return Array.from(this.vm.selectedLangs, (lang) => {
			return this.angularFilterHelperService.translate('Services.Language.' + lang);
		}).join(', ');
	}
	
	getTagsText() {
		if (!this.vm.selectedTags || !this.vm.selectedTags.length) return this.angularFilterHelperService.translate('Services.Filter.Tags');
		return Array.from(this.vm.selectedTags, (tag) => {
			for (var i = 0; i < this.vm.searchTags.length; i++) {
				if (this.vm.searchTags[i].tag.name === tag) {
					return this.vm.searchTags[i].translation;
				}
			}
		}).join(', ');
	}
	
	handleServiceProviderSearch = (userInput: any): void => {
		var namePart = userInput.namePart;
		
		var searchParams: any = { pageSize: 20, origin: this.vm.chat.privateChatFriend.origin };
		var langs: any = '';
		var tags: any = '';
		if (this.vm.selectedLangs) {
			langs = this.vm.selectedLangs.join(',');
			searchParams.languages = langs;
		}
		if (this.vm.selectedTags) {
			tags = this.vm.selectedTags.join(',');
			searchParams.tags = tags;
		}
		if (namePart) {
			searchParams.name = namePart;
		}
		
		if (!langs && !namePart && !tags) {
			return;
		}
		
		if (this.vm.isMentalHealthServiceProvider) {
			searchParams.subcategory = 'MENTAL_HEALTH';
		}
		searchParams.withoutTimeslot = true;
		
		var deferred: any = this.angularHelperService.getDeferredPromise();
		this.restService.getServiceProviderSearch(searchParams)
			.then((serviceProviders) => {
				serviceProviders.forEach((serviceProvider) => {
					serviceProvider.name = serviceProvider.user.firstname + ' ' + serviceProvider.user.lastname;
					if (serviceProvider.user.profilePicture) {
						serviceProvider.picture = serviceProvider.user.profilePicture.thumbnailUrl;
					}
					var params = { subcategory: serviceProvider.subcategory, furtherSubcategory: serviceProvider.furtherSubcategory };
					serviceProvider.occupation = this.categoryService.getTranslationUsingDictionary(this.vm.healthFields, params);
					serviceProvider.extra = serviceProvider.parentServiceTitle + ', ' + serviceProvider.occupation;
				});
				deferred.resolve(serviceProviders);
			})
			.catch((err) => {
				console.error(err);
				deferred.reject(err);
			});
		
		return deferred.promise;
	}
	
	close() {
		this.dialogRef.close(this.vm.chat);
	}
	
}